// Dải tóm tắt ở đầu bảng cấu hình bot Telegram.
//
// Bảng này dài 5 khối, phải cuộn hết mới biết bot đang bật hay tắt, khai được mấy
// nguồn. Dải này trả lời trong 1 dòng, đứng ngay dưới tiêu đề.
import React from "react";
import { Tag, Tooltip } from "antd";

/** 1 con số + nhãn, gạch dọc ngăn cách. */
const Stat = ({ value, label, hint }) => (
    <Tooltip title={hint}>
        <span className="whitespace-nowrap">
            <span className="font-semibold">{value}</span> <span className="text-gray-500">{label}</span>
        </span>
    </Tooltip>
);

export default function TelegramConfigSummaryBar({ config, offset, pendingCount }) {
    return (
        <div className="flex items-center gap-3 flex-wrap text-sm mb-4 px-3 py-2 rounded bg-gray-50 border border-gray-200">
            {config.enabled ? (
                <Tag color="green" className="!mr-0">
                    Đang bật
                </Tag>
            ) : (
                <Tag color="default" className="!mr-0">
                    Đang tắt
                </Tag>
            )}
            <Stat value={config.chats.length} label="nguồn" hint="Nhóm/kênh Telegram đã khai" />
            <span className="text-gray-300">|</span>
            <Stat value={config.senders.length} label="người đăng" hint="Tài khoản Telegram được phép đăng" />
            <span className="text-gray-300">|</span>
            <Stat
                value={(config.hashtagRoutes || []).length}
                label="luật thẻ"
                hint="Luật hashtag → danh mục"
            />
            {/* Còn nguồn chưa khai là việc cần làm — tô cam cho nổi. */}
            {pendingCount > 0 && (
                <Tag color="orange" className="!mr-0">
                    {pendingCount} nguồn chưa khai
                </Tag>
            )}
            <span className="flex-1" />
            {/* Mốc đọc tin: đứng yên nhiều giờ trong khi nhóm vẫn có tin = worker chết. */}
            <Tooltip title="Vị trí đọc tin gần nhất của worker (update_id). Nhóm có tin mới mà số này đứng yên ⇒ kiểm tra pm2 telegram-worker.">
                <span className="text-xs text-gray-400">đã đọc tới #{offset || 0}</span>
            </Tooltip>
        </div>
    );
}
